<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Stand Info</h3>
      </div>
      <form @submit.prevent>
        <div class="form-group text-left">
          <label for="standWidth">Width (in inces)</label>
          <base-input class="mb-3"
                      id="standWidth"
                      required='required'
                      placeholder=""
                      name='standWidth'
                      v-model="standInfo.standWidth"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('standWidth')">
          </base-input>
        </div>
        <div class="form-group text-left">
          <label for="cleanedStand">Header Capable</label>
          <select class="form-control" :class="{'is-invalid': vErrors.first('capableHeader') }"
            name="capableHeader"
            v-model="standInfo.capableHeader"
            id="capableHeader"
            v-validate="'required'"
            data-vv-validate-on="blur">
            <option value="" disabled></option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('capableHeader') }}</span>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="standType">Stand type</label>
          <select class="form-control" :class="{'is-invalid': vErrors.first('standType') }"
            name="standType"
            v-model="standInfo.standType"
            id="standType"
            v-validate="'required'"
            data-vv-validate-on="blur">
            <option value="" disabled></option>
            <option value="wood">Wood</option>
            <option value="metal">Metal</option>
            <option value="wire">Wire</option>
            <option value="eb">EB</option>
            <option value="funcard">FunCard</option>
            <option value="other">Other</option>
          </select>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('standType') }}</span>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="standColor">Stand color</label>
          <select class="form-control" :class="{'is-invalid': vErrors.first('standColor') }"
            name="standColor"
            v-model="standInfo.standColor"
            id="standColor"
            v-validate="'required'"
            data-vv-validate-on="blur">
            <option value="" disabled></option>
            <option value="mahogany">Mahogany</option>
            <option value="oak">Oak</option>
            <option value="walnut">Walnut</option>
            <option value="black">Black</option>
            <option value="silver">Silver</option>
            <option value="white">White</option>
            <option value="mocha">Mocha</option>
            <option value="other">Other</option>
          </select>
          <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
            <span>{{ vErrors.first('standColor') }}</span>
          </div>
        </div>
        <div class="form-group text-left">
          <label for="standPockets">Pockets</label>
          <base-input class="mb-3"
                      id="standPockets"
                      required='required'
                      placeholder=""
                      name='standPockets'
                      v-model="standInfo.standPockets"
                      type="text"
                      addonRightIcon=''
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :error="vErrors.first('standPockets')">
          </base-input>
        </div>
        <div class="text-center">
            <base-button :disabled="disableSubmitButton" v-if="showSubmitButton() && !isJobActionCopleted(5)" type="primary" @click="standInfoSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import camera from './Camera'
import signatures from './Signatures'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      standInfo: {
        standWidth: null,
        capableHeader: null,
        standType: null,
        standColor: null,
        standPockets: null
      }
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    standInfoSend () {
      this.$validator.validateAll({
        standWidth: this.standInfo.standWidth,
        capableHeader: this.standInfo.capableHeader,
        standType: this.standInfo.standType,
        standColor: this.standInfo.standColor,
        standPockets: this.standInfo.standPockets
      }).then(response => {
        if (response) {
          this.$emit('standInfoFormDataSend', this.standInfo)
        }
      })
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
<style>
</style>
